import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { getSinlgeProduct, updateProduct } from '../../../../../services/api/ProductAPI';
import ViewProduct from './VendorEdit';
import BasicDetailsCard from '../../../../../components/common/BasicDetailsCard';
import { ProductApprovel } from '../../../../../services/api/Vendorpage/approverproduct';
import { MyModal } from '../../Vendor-ui/Modal';
import MySnackbarModal from '../../Vendor-ui/SnackbarModal';

export default function VendorSingleview() {
	const { id } = useParams();
	const [product, setProduct] = useState<any>(null);
	const [editenabel, setEditEnabel] = useState(true);
	const [loader, setLoader] = useState(false);
	const [vendorApprove, setVendorApprove] = useState(null);
	console.log(vendorApprove, 'vendorApprove');
	// modal states
	const [modalOpen, setModalOpen] = useState(false);
	const [modalAction, setModalAction] = useState<'approve' | 'reject' | null>(null);

	// snackbar states
	const [snackbar, setSnackbar] = useState<{
		open: boolean;
		message: string;
		severity: 'approve' | 'reject' | null;
	}>({
		open: false,
		message: '',
		severity: 'approve',
	});

	const fetchProduct = async () => {
		const response = await getSinlgeProduct(id);
		if (response.success) {
			setProduct(response?.data?.product);
		}
	};

	useEffect(() => {
		fetchProduct();
	}, []);

	// ✅ update product
	const handleSubmit = async (formDataToSend: any, productId: string) => {
		try {
			const response = await updateProduct(formDataToSend, productId);

			if (response.success) {
				setSnackbar({
					open: true,
					message: 'Product updated successfully!',
					severity: 'approve',
				});
			} else {
				setSnackbar({
					open: true,
					message: response?.data?.message || 'Update failed',
					severity: 'reject',
				});
			}
			return response;
		} catch (err) {
			console.error('Update error:', err);
			setSnackbar({
				open: true,
				message: 'Update failed due to an error',
				severity: 'reject',
			});
			return { isError: true, data: { message: 'Update failed' } };
		}
	};

	// ✅ approve/reject API
	const handleApprovalAction = async (action: 'approve' | 'reject', reason?: string) => {
		try {
			setLoader(true);
			const payload = { action, reason };
			const response = await ProductApprovel(
				`admin/product/vendor/${product?._id}/products`,
				payload
			);
			console.log(response, 'approve');
			if (response.success) {
				// refresh product details
				setModalOpen(false);

				setSnackbar({
					open: true,
					message: `Product ${action === 'approve' ? 'approved' : 'rejected'} successfully`,
					severity: 'approve',
				});
			} else {
				setModalOpen(false);
				setSnackbar({
					open: true,
					message: response?.message || 'Action failed',
					severity: 'reject',
				});
			}
		} catch (err) {
			console.error('Approval error:', err);
			setSnackbar({
				open: true,
				message: 'Something went wrong while processing action',
				severity: 'reject',
			});
		} finally {
			setLoader(false);
		}
	};

	return (
		<>
			<Box
				sx={{
					height: '100%',
					maxHeight: 'calc(90vh - 30px)',
					overflowY: 'auto',
					marginTop: '20px',
				}}
			>
				<Box sx={{ py: 3 }}>
					<BasicDetailsCard vendor={product?.createdBy} />
				</Box>

				<ViewProduct
					product={product}
					editenabel={editenabel}
					handleSubmit={handleSubmit}
					setModalOpen={setModalOpen}
					setEditEnabel={setEditEnabel}
					setModalAction={setModalAction}
					setVendorApprove={setVendorApprove}
				/>
			</Box>

			{/* Confirmation Modal */}
			<MyModal
				loader={loader}
				open={modalOpen}
				action={modalAction}
				onClose={() => setModalOpen(false)}
				onConfirm={(reason?: string) => handleApprovalAction(modalAction!, reason)}
				vendorApprove={vendorApprove}
			/>

			{/* ✅ Snackbar */}
			<MySnackbarModal
				open={snackbar.open}
				Message={snackbar.message}
				action={snackbar.severity}
				onClose={() => setSnackbar({ ...snackbar, open: false })}
				// position={{ vertical: 'bottom', horizontal: 'right' }}
			/>
		</>
	);
}
